function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.669 12L11 4H8l.331 8zM9.495 16c.452 0 .816-.141 1.092-.423.275-.282.413-.64.413-1.072 0-.44-.138-.8-.413-1.082-.276-.282-.64-.423-1.092-.423-.445 0-.806.143-1.082.428-.275.285-.413.644-.413 1.077 0 .433.138.79.413 1.072.276.282.637.423 1.082.423z"
})));

function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAlert;